import { Button } from "@arco-design/web-react";
import React from "react";
import Logo from "../../assets/images/pixl_logo_black 1.png";
import { useState } from "react";

function RightPanel() {
  const [panelVisible, setPanelVisible] = useState(false);
  return (
    <>
      <div className="position-fixed end-0 top-0 mt-3 me-3 z-1">
        <div
          className="bg-white shadow rounded-3 cursor-pointer px_hover_1 p-2 mt-3 mt-lg-2 me-3 me-lg-2"
          onClick={() => {
            setPanelVisible(!panelVisible);
          }}
        >
          <i className="fas fa-history font_16 px-1"></i>
        </div>
      </div>
      <div
        className={`${
          panelVisible ? "" : "hide"
        } right__panel bg-white rounded p-1  `}
      >
        <div className="h-100 w-100 d-flex flex-column">
          <div className="align-items-center bg-white d-flex justify-content-between gap-2 pb-4 position-sticky pt-3 px-3 top-0 z-1">
            <h6 className="fw_600 mb-0">
              History</h6>
              <span className="d-inline-flex text_dark_gray">
          <i className="fas fa-times font_20" onClick={() => {
            setPanelVisible(false);
          }}></i>
        </span>
              
          </div>
          <div className="h-100 overflow-auto px-3 scrollbar1">
            <div className="pb-3">
              <h6 className="font_14 fw_600">Today</h6>
              <ul className="d-grid gap-3 list-unstyled mb-0">
                <li className="cursor-pointer d-flex gap-3 px_hover_1 text_gray4 py-1">
                  <p className="mb-0 font_12">
                    Best Practices for Document Processing
                  </p>
                </li>
              </ul>
            </div>
            <div className="pb-3">
              <h6 className="font_14 fw_600">Last Week</h6>
              <ul className="d-grid gap-2 list-unstyled mb-0">
                <li className="cursor-pointer d-flex gap-3 px_hover_1 text_gray4 py-1">
                  <p className="mb-0 font_12">
                    That sounds great. Can I integrate it with my existing
                    systems?
                  </p>
                </li>
                <li className="cursor-pointer d-flex gap-3 px_hover_1 text_gray4 py-1">
                  <p className="mb-0 font_12">
                    That sounds great. Can I integrate it with my existing
                    systems?
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RightPanel;
